// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CbS7KUMoFbcSqn {
  position: relative;
}
.CbS7KUMoFbcSqn .hhOP0ehXCOA_Uv {
  margin-bottom: var(--ds-space-300, 24px);
}
.CbS7KUMoFbcSqn tbody {
  background-color: transparent;
}
.CbS7KUMoFbcSqn .ssfvZALagXFfCe {
  position: absolute;
  right: var(--ds-space-0, 0);
  bottom: var(--ds-space-0, 0);
}
@media only screen and (max-width: 600px) {
  .CbS7KUMoFbcSqn .ssfvZALagXFfCe {
    position: relative;
    margin-top: var(--ds-space-100, 8px);
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paymentModal": `CbS7KUMoFbcSqn`,
	"description": `hhOP0ehXCOA_Uv`,
	"backToPlansButton": `ssfvZALagXFfCe`
};
export default ___CSS_LOADER_EXPORT___;
